/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from 'react';
import {
  Tooltip,
  IconButton,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import tableStyle, { ImgSearch } from './components/tableStyle';
import newButton from '../../assets/img/iconos/newButton.svg';
import reload from '../../assets/img/iconos/reload.svg';
import searchIcon from '../../assets/img/iconos/searchIcon.svg';
import ScreensTable from './components/DataTable.readonly';
import ActionForm from './components/ActionForm.readonly';
import { Loading, Toaster } from '../../components';
import {
  useRegisteredRoles,
  useRegisteredScreens,
} from '../../services';

const ReadOnlyRolesRegisterScreen = () => {
  const [enteredFilter, setEnteredFilter] = useState('');
  const [alert, setAlert] = useState({ status: false, type: '', message: '' });
  const [screensOptions, setScreensOptions] = useState([]);
  const [popUpAction, setPopUpAction] = useState({ open: false, title: '', data: null });
  const classes = tableStyle();

  const {
    loading,
    data: dataRoles,
    error: errorGetAllRoles,
    getAllRoles,
  } = useRegisteredRoles();

  const {
    loading: loadingScreens,
    data: dataScreens,
    error: errorGetScreens,
    getScreens,
  } = useRegisteredScreens();

  const defaultData = {
    id: '',
    description: '',
    active: true,
    permissions: [],
    screens: '',
  };
  const [defaultValues, setDefaultValues] = useState(defaultData);

  const openCategoryForm = () => {
    setPopUpAction({
      open: true,
      title: 'Registrar nuevo rol',
      data: null,
    });
  };

  const initData = async () => {
    getAllRoles();
    getScreens();
  };

  useEffect(() => {
    if (dataScreens) {
      const optionsTypes = dataScreens.map(
        (item) => ({ value: `${item.screenName}`, label: item.screenName }),
      );
      setScreensOptions(optionsTypes);
    }
  }, [dataScreens]);

  useEffect(() => {
    initData();
  }, []);

  useEffect(() => {
    if (errorGetAllRoles || errorGetScreens) {
      setAlert({
        status: true,
        type: 'error',
        message: `Ha ocurrido un error, intente nuevamente.
      ${errorGetAllRoles?.message || errorGetScreens?.message || ''}`,
      });
    }
  }, [errorGetAllRoles, errorGetScreens]);

  return (
    <>
      {(loading || loadingScreens) && <Loading />}
      <>
        <TextField
          className={classes.searchTextField}
          value={enteredFilter}
          onChange={(e) => setEnteredFilter(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <ImgSearch src={searchIcon} alt="searchIcon" />
              </InputAdornment>
            ),
            disableUnderline: true,
          }}
          placeholder="Buscar"
        />
        <Tooltip title="Refrescar página" aria-label="Refrescar página">
          <IconButton
            onClick={getAllRoles}
            style={{ fontSize: '20px', float: 'right' }}
            edge="end"
            size="small"
          >
            <img src={reload} alt="reload" />
          </IconButton>
        </Tooltip>
        <IconButton
          onClick={openCategoryForm}
          style={{ fontSize: '20px', float: 'right' }}
          edge="end"
          size="small"
          disabled
        >
          <img src={newButton} alt="newButton" style={{ opacity: 0.4 }} />
        </IconButton>
        <Toaster
          show={alert.status}
          type={alert.type}
          text={alert.message}
          onClose={() => setAlert({ ...alert, status: false })}
        />
      </>
      <ScreensTable
        screens={dataRoles}
        getAllRoles={getAllRoles}
        setPopUpAction={setPopUpAction}
        setDefaultValues={setDefaultValues}
        enteredFilter={enteredFilter}
      />
      <ActionForm
        open={popUpAction.open}
        data={popUpAction.data}
        title={popUpAction.title}
        setDefaultValues={setDefaultValues}
        defaultValues={
          {
            ...defaultValues,
          }
        }
        onClose={() => {
          setPopUpAction({ open: false, title: '', data: null });
        }}
        setAlertHome={setAlert}
        getAllRoles={getAllRoles}
        screensData={screensOptions}
      />
    </>
  );
};

export default ReadOnlyRolesRegisterScreen;
